import React from "react";
import { Card, Row, Col, Skeleton } from "antd";

interface LoadingSkeletonProps {
  type?: "dashboard" | "list" | "detail" | "analytics";
}

/**
 * Reusable loading skeleton component for different page types
 */
export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ type = "list" }) => {
  if (type === "dashboard") {
    return (
      <div style={{ padding: 24 }}>
        <Row gutter={[16, 16]}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Col xs={24} sm={12} md={8} key={i}>
              <Card>
                <Skeleton active paragraph={{ rows: 1 }} />
              </Card>
            </Col>
          ))}
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col xs={24} lg={12}>
            <Card>
              <Skeleton active paragraph={{ rows: 8 }} />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card>
              <Skeleton active paragraph={{ rows: 8 }} />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  if (type === "detail") {
    return (
      <div style={{ padding: 24 }}>
        <Card>
          <Skeleton active paragraph={{ rows: 15 }} />
        </Card>
      </div>
    );
  }

  if (type === "analytics") {
    return (
      <div style={{ padding: 24 }}>
        <Row gutter={[16, 16]}>
          {[1, 2, 3, 4].map((i) => (
            <Col xs={24} sm={12} md={6} key={i}>
              <Card>
                <Skeleton active paragraph={{ rows: 1 }} />
              </Card>
            </Col>
          ))}
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col xs={24} lg={12}>
            <Card>
              <Skeleton active paragraph={{ rows: 10 }} />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card>
              <Skeleton active paragraph={{ rows: 10 }} />
            </Card>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col xs={24} lg={12}>
            <Card>
              <Skeleton active paragraph={{ rows: 10 }} />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card>
              <Skeleton active paragraph={{ rows: 10 }} />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  // Default: list
  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Skeleton active paragraph={{ rows: 10 }} />
      </Card>
    </div>
  );
};
